//generic title block
const Title = ({ scrollTo, title, subTitle }) => {
  return (

    <div className="text-center p-top-100 title-block" id={scrollTo} >
      <div className="container">
        <div className="row">
          {/* <div className="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3"> */}
          <div className="col-12">
            <div className="heading text-center title-wrapper">
              {subTitle ? <p className="heading-subtitle">{subTitle}</p> : null}
              {title ? <h2 className="heading-title">{title}</h2> : null}
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default Title;